import script from "./UsersTable.vue?vue&type=script&setup=true&lang=js"
export * from "./UsersTable.vue?vue&type=script&setup=true&lang=js"

import "./UsersTable.vue?vue&type=style&index=0&id=23f7e6de&lang=css"

const __exports__ = script;

export default __exports__